/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoRarIcon16Regular = forwardRef('GovKoRarIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4.48 0a.227.227 0 0 0-.226.217c-.1 1.947 1.54 3.621 3.529 3.53A.227.227 0 0 0 8 3.52C8.03 1.598 6.403-.02 4.48 0Z" }),
        React.createElement("path", { d: "M3.873 8.092a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M9.5 6.592a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M9.5 13.708a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M13.627 6.592a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M5.937 11.65a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
        React.createElement("path", { d: "M11.563 10.15a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" })));
});
